import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Icon_L from "../../assets/images/Icon_L.svg";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";
import {
  setLocalStorageItem,
  getLocalStorageItem,
} from "../../utils/localStorage";
import * as toast from "../../utils/makeToast";
import { glCodes } from "../../utils/constants";
import { encryptRequest } from "../../utils/encryption";

function ExBvnValidationDialog(props: any) {
  const [inputs, setInputs] = useState<any>({});

  const [validating, setValidating] = useState(false);

  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values: any) => ({ ...values, [name]: value }));
  };

  const [accountType, setAccountType] = useState(
    localStorage.getItem("altFinanceAccountType")
  );

  const dispatch = useDispatch();

  const handleValidateBVN = () => {
    
    if (checkFormValidity()) {
      setValidating(true);
      checkAccountNumbersBVN();
    } else {
      
    }
  };

  const validateBVN = () => {
    let validateBVNPayload = {
      ...inputs,
    };
    
    // return
    let userDetails = getLocalStorageItem("userDetails") || {};
    setLocalStorageItem(
      "userDetails",
      JSON.stringify({ ...userDetails, bvn: inputs.bvn })
    );
    // (validateBVNPayload)
    axios
      .post(
        `${baseUrl}Authentication/BvnAccountNumberValidation`,
        validateBVNPayload
      )
      .then((response) => {
        
        setLocalStorageItem(
          "userNinPayload",
          JSON.stringify({
            firstName: response.data.firstName,
            lastName: response.data.lastName,
            middleName: response.data.middleName,
            phoneNumber: response.data.phoneNumber,
            gender: response.data.gender,
            dob: response.data.dateOfBirth,
          })
        );
        if (response.data.isSuccess) {
          // toast.successToast(response.data.otp)
          
          let userInfo = getLocalStorageItem("userDetails") || {};
          setLocalStorageItem(
            "userDetails",
            JSON.stringify({
              ...userInfo,
              firstName: response.data.firstName,
              lastName: response.data.lastName,
              middleName: response.data.middleName,
              phoneNumber: response.data.phoneNumber,
              accountDetails: response.data.accountDetails,
            })
          );
          dispatch(setAccountOpeningStep("otp"));
        } else {
          toast.errorToast(response.data.responseMessage);
        }
        setValidating(false);
      })
      .catch((err) => {
        // toast.errorToast('something went wrong')
        
        setValidating(false);
      });
  };

  const checkAccountNumbersBVN = () => {
    if (checkFormValidity()) {
      setValidating(true);
      let accountGlCodeToOpen = localStorage.getItem("altFinanceGlCode");
      let accountTypeToOpen = localStorage.getItem("altFinanceAccountType");
      let accountExistsToastText =
        "already exists for this bvn. Please use the existing customer option.";

      // axios.get(`${baseUrl}Authentication/AllAccountNumberByBvn?Bvn=${encryptRequest(inputs.bvn)}`)
      const allAccountNumberByBvnPayload = {
        bvn: inputs.bvn,
      };
      axios
        .post(
          `${baseUrl}Authentication/AllAccountNumberByBvn`,
          allAccountNumberByBvnPayload
        )
        .then((response) => {
          
          if (!response.data) {
            validateBVN();
          }
          if (response?.data?.length === 0) {
            validateBVN();
          }
          if (response?.data?.length > 0) {
            let swiftAccount = response.data.find(
              (x) => x.gL_CODE == glCodes.SWIFT_SAVINGS
            );
            let currentAccount = response.data.find(
              (x) => x.gL_CODE == glCodes.CURRENT
            );
            let regularSavingsAccount = response.data.filter(
              (x) => x.gL_CODE == glCodes.REGULAR_SAVINGS
            );
            if (accountGlCodeToOpen == glCodes.SWIFT_SAVINGS && swiftAccount) {
              toast.errorToast("You already have a swift savings account");
              setValidating(false);
              return;
            }
            // if(accountGlCodeToOpen == glCodes.CURRENT && currentAccount && currentAccount?.currency === 'NGN'){
            //     toast.errorToast('You already have a current account')
            //     setValidating(false)
            //     return
            // }
            if (
              accountGlCodeToOpen == glCodes.SWIFT_SAVINGS &&
              regularSavingsAccount
            ) {
              toast.errorToast(
                "You already have a regular savings account and cannot open a swift savings account"
              );
              setValidating(false);
              return;
            }
            if (
              accountGlCodeToOpen == glCodes.REGULAR_SAVINGS &&
              regularSavingsAccount.length > 1
            ) {
              if (
                regularSavingsAccount[0]?.currency === "NGN" &&
                regularSavingsAccount[1]?.currency === "NGN"
              ) {
                toast.errorToast("You already have 2 regular savings account");
                setValidating(false);
                return;
              }
            }
            validateBVN();
          }
        })
        .catch((err) => {
          toast.errorToast("something went wrong");
          setValidating(false);
        });
    }
  };

  // const handleValidateBVN = () => {
  //     (inputs)
  //     if (checkFormValidity()) {
  //         setValidating(true)
  //         validateBVN()
  //     }
  //     else {
  //         ('invalid form')
  //     }
  // }

  // const validateBVN = () => {
  //     let validateBVNPayload = {
  //         ...inputs
  //     }
  //     (validateBVNPayload)
  //     // return
  //     let userDetails = getLocalStorageItem('userDetails') || {}
  //     setLocalStorageItem('userDetails', JSON.stringify({ ...userDetails, bvn: inputs.bvn }))
  //     // (validateBVNPayload)
  //     axios.post(`${baseUrl}Authentication/BvnAccountNumberValidation`, validateBVNPayload)
  //         .then((response) => {
  //             (response)
  //             if (response.data.isSuccess) {
  //                 // toast.successToast(response.data.otp)
  //                 ('otp', response.data.otp)
  //                 let userInfo = getLocalStorageItem('userDetails') || {}
  //                 setLocalStorageItem('userDetails', JSON.stringify({
  //                     ...userInfo,
  //                     firstName: response.data.firstName,
  //                     lastName: response.data.lastName,
  //                     middleName: response.data.middleName,
  //                     phoneNumber: response.data.phoneNumber,
  //                     accountDetails: response.data.accountDetails
  //                 }))
  //                 dispatch(setAccountOpeningStep('otp'))
  //             }
  //             else {
  //                 toast.errorToast(response.data.responseMessage)
  //             }
  //             setValidating(false)
  //         })
  //         .catch((err) => {
  //             toast.errorToast('something went wrong')
  //             setValidating(false)
  //         })
  // }

  const checkFormValidity = () => {
    if (
      !inputs?.bvn ||
      inputs?.bvn?.length < 11 ||
      inputs?.bvn?.length > 11 ||
      !inputs?.accountNumber ||
      inputs?.accountNumber?.length < 10 ||
      inputs?.accountNumber?.length > 10
    ) {
      return false;
    } else {
      return true;
    }
  };

  const removeGeneratedAccountNumbersFromLocalStorage = () => {
    localStorage.removeItem("generatedAccountNumber");
    localStorage.removeItem("generatedAccountNumberDom");
    localStorage.removeItem("generatedAccountNumberDomSavings");
  };

  useEffect(() => {
    
    removeGeneratedAccountNumbersFromLocalStorage();
  }, []);

  return (
    <div>
      <div className=" card-form pl-5 pr-5">
        <div className="card-body">
          <h4 className="card-title text-center pl-5 mt-4">Validation</h4>
          <div className="bvn_val mb-4">
            <img src={Icon_L} alt="" />

            <small className="sterling-grey-text ml-4">
              Kindly ensure that your BVN information is up to date
            </small>
          </div>
          <label htmlFor="gender" className="fila">
            Existing account number
          </label>
          <div className="form-group">
            <input
              name="accountNumber"
              onChange={handleChange}
              maxLength={10}
              className="form-control bvn_input text-muted border-dark"
              type="text"
              id="accountNumber"
              placeholder="Enter your existing alternative bank account number"
            />
          </div>
          <div className="form-group mt-4">
            <div className="d-flex justify-content-between pb-1 fillup">
              <label htmlFor="name" className="fila">
                Enter BVN
              </label>
              <i
                className="bx bxs-info-circle"
                data-toggle="tooltip"
                data-placement="bottom"
                title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
              ></i>
            </div>
            <input
              name="bvn"
              onChange={handleChange}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              maxLength={11}
              className="form-control bvn_input text-muted border-dark"
              type="text"
              id="bvn"
              placeholder="Enter your BVN"
            />
          </div>

          <div className="d-flex justify-content-end mt-4">
            {validating ? (
              <div className="spinner-border text-gold" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button
                className="btn btn-dange float-right btn-filled-red"
                onClick={handleValidateBVN}
              >
                Validate
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExBvnValidationDialog;
